exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-vision-board[data-v-e93c86bc] {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n}\nh1[data-v-e93c86bc] {\n    margin-bottom: 2rem;\n}\nh2[data-v-e93c86bc] {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n}\n", ""]);

// exports
